import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { KioskPickerModalLauncherBlockConfig } from '@front-platform/content-builder';
import { kioskPickerModalLauncherBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnDestroy, OnInit, input } from '@angular/core';

import { KioskService } from '@core/services/kiosk/kiosk.service';
import { ModalsService } from '@core/services/modals/modals.service';

import { KioskPickerModalComponent } from '@shared/modals/kiosk-picker-modal/kiosk-picker-modal.component';
export interface KioskPickerModalLauncherBlockRuntimeConfig {}

export type KioskPickerModalLauncherBlockConfigInput = Partial<
  Omit<KioskPickerModalLauncherBlockConfig, keyof KioskPickerModalLauncherBlockRuntimeConfig> &
    KioskPickerModalLauncherBlockRuntimeConfig
>;
export type KioskPickerModalLauncherBlockResolvedConfig = Omit<
  KioskPickerModalLauncherBlockConfig,
  keyof KioskPickerModalLauncherBlockRuntimeConfig
> &
  Partial<KioskPickerModalLauncherBlockRuntimeConfig>;
export interface KioskPickerModalLauncherBlockContract extends ConfigComponentContract<
  KioskPickerModalLauncherBlockConfigInput,
  KioskPickerModalLauncherBlockResolvedConfig
> {}

@Component({
  template: ``,
  selector: 'app-kiosk-picker-modal-launcher-block',
  standalone: false,
})
export class KioskPickerModalLauncherBlockComponent
  implements OnInit, OnDestroy, KioskPickerModalLauncherBlockContract
{
  readonly config = input<KioskPickerModalLauncherBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    KioskPickerModalLauncherBlockConfig,
    KioskPickerModalLauncherBlockRuntimeConfig
  >(kioskPickerModalLauncherBlockResolveConfig, () => ({ config: this.config() }));

  constructor(
    private readonly kioskService: KioskService,
    private readonly modalsService: ModalsService,
  ) {}

  ngOnInit(): void {
    const kioskId = this.kioskService.getKioskIdFromStore();
    if (!kioskId) {
      this.modalsService.open(KioskPickerModalComponent.handle);
    }
  }

  ngOnDestroy(): void {
    this.modalsService.close(KioskPickerModalComponent.handle);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(KioskPickerModalLauncherBlockComponent, {
  'keyAliases': {},
});
